module.exports = __webpack_public_path__ + "static/media/referral-rightbg.39a7683d.jpg";